// src/components/sponsor/layout/SponsorLayout.jsx
import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchSponsorProfile, silentRefreshSponsor } from "@/store/slices/sponsorSlice";
import SponsorSidebar from "./SponsorSidebar";
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
import Loading from "@/components/common/Loading";

const SponsorLayout = () => {
  const [collapsed, setCollapsed] = React.useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, sponsor, isLoading } = useSelector((state) => state.sponsor);

  useEffect(() => {
    // Attempt silent refresh on layout mount to restore session
    if (!isAuthenticated && !sponsor) {
      dispatch(silentRefreshSponsor());
    }
  }, [dispatch, isAuthenticated, sponsor]);

  useEffect(() => {
    // Once authenticated, fetch full profile if not loaded
    if (isAuthenticated && !sponsor && !isLoading) {
      dispatch(fetchSponsorProfile());
    }
    // If not loading and not authenticated, redirect to login
    if (!isLoading && !isAuthenticated) {
      navigate("/sponsor/login");
    }
  }, [dispatch, navigate, sponsor, isAuthenticated, isLoading]);

  if (isLoading && !sponsor) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <Loading />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col bg-gray-50 dark:bg-gray-900">
      <Header />

      <div className="flex flex-1 pt-[72px]">
        <SponsorSidebar collapsed={collapsed} setCollapsed={setCollapsed} />

        <div className="flex-1 flex flex-col min-w-0">
          <main className="flex-1 p-6 md:p-8">
            <div className="max-w-[1300px] mx-auto">
              <Outlet />
            </div>
          </main>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default SponsorLayout;
